/** @jsx jsx */
import { Box, Button, jsx } from "theme-ui";
import React, { Fragment, useState } from "react";
import { BuilderBlocks, Builder } from "@builder.io/react";
import { Flex } from "theme-ui";
import Chevron from "../../components/design-elements/chevron";

// 2. Create your component.
// This is an accordian component with some basic styles. When the user clicks
// on a tab, that content becomes active.
function Accordian(props: any) {
  const [activeItem, setActiveItem] = useState(0);
  return (
    <Fragment>
      <Flex variant="accordion">
        {props.items?.map((item: any, index: number) => (
          <Box key={index} variant="accordion.item">
            <Box>
              <Button
                variant="accordion.header"
                onClick={() => setActiveItem(index)}
              >
                <Flex
                  sx={{ justifyContent: "space-between", alignItems: "center" }}
                >
                  <Box sx={{ width: "90%" }}>{item.label}</Box>
                  <Flex
                    variant={
                      index === activeItem ? "accordion.chevron.open.bg" : ""
                    }
                    sx={{
                      justifyContent: "center",
                      alignItems: "center",
                      minWidth: "30px",
                      minHeight: "30px",
                    }}
                  >
                    <Chevron
                      sx={{
                        width: "15px",
                        height: "15px",
                        variant:
                          index === activeItem
                            ? "accordion.chevron.open"
                            : "accordion.chevron",
                      }}
                    ></Chevron>
                  </Flex>
                </Flex>
              </Button>
              {activeItem === index && (
                <Box variant="accordion.itemPanel">
                  <BuilderBlocks
                    parentElementId={props.builderBlock.id}
                    dataPath={`component.options.items.${activeItem}.content`}
                    blocks={props.items[activeItem].content}
                  />
                </Box>
              )}
            </Box>
          </Box>
        ))}
      </Flex>
    </Fragment>
  );
}

export default Accordian;
// 3. Configure BuilderBlocks. The above section with BuilderBlocks tells Builder what to expect:
// the parent id, the path to the child component,
// and what the blocks should be made of.
// Here, the blocks are made of the content of the active tab

// 4. Register your component. This component is called Tabs, is of type list and contains two subFields: a label and the content.
// As a best practice, provide a defaultValue. The default label is "Tab 1" and the content is an empty array.
